// @flow

import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { localize } from "redux-i18n";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  LinearWizard,
  Step,
} from "@components";
import * as employeeSelectors from "@modules/employee/selectors";
import actionCreators from "@modules/employee/actionCreator";
import Step1ChooseAlert from "./step1-choose-alert";
import Step2ReasonForAlertExclusion from "./step2-reason-for-alert-exclusion";
import type { State } from "@store/reducers";

type PropsFromState = $Exact<{
  alertId: number,
  exclusionReasonDetails: Object,
}>;

type PropsFromDispatch = $Exact<{
  setShowExcludeEmployeeFromAlertsAddModal: typeof actionCreators.SetShowExcludeEmployeeFromAlertsAddModal,
  addAlertExclusion: typeof actionCreators.AddAlertExclusion,
  clearDataAlertExlusionForm: typeof actionCreators.ClearDataAlertExlusionForm,
}>;

type OwnProps = $Exact<{
  clientId: number,
  employeeId: number,
  defaultStep: number,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class ExcludeEmployeeFromAlertsAddWizard extends Component<Props> {
  handleCancel = () => {
    this.props.setShowExcludeEmployeeFromAlertsAddModal({ show: false, step: 1 });
    this.props.clearDataAlertExlusionForm();
  };

  handleSubmitExcludeEmployeeFromAlerts = () => {
    this.props.addAlertExclusion({
      clientId: this.props.clientId,
      employeeId: this.props.employeeId,
      formData: {
        alertConfiguration: {
          id: this.props.alertId,
        },
        ...this.props.exclusionReasonDetails,
      },
    });
  };

  render() {
    return (
      <Modal className="modal-large">
        <ModalHeader className="d-flex justify-content-between" toggle={this.handleCancel}>
          {this.props.t("ADD_ALERT_EXCLUSION")}
        </ModalHeader>
        <ModalBody className="d-flex flex-column align-content-center">
          <LinearWizard defaultStep={this.props.defaultStep} data={[]}>
            <Step
              component={Step1ChooseAlert}
              title={this.props.t("CHOOSE_ALERT")}
              clientId={this.props.clientId}
            />
            <Step
              component={Step2ReasonForAlertExclusion}
              title={this.props.t("REASON_FOR_ALERT_EXCLUSION")}
            />
          </LinearWizard>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.handleCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button
            materialIcon="save"
            onClick={this.handleSubmitExcludeEmployeeFromAlerts}
            disabled={!this.props.alertId || !this.props.exclusionReasonDetails}
          >
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state: State, ownProps: Object): PropsFromState => {
  return {
    alertId: employeeSelectors.getClientAlertId(state),
    exclusionReasonDetails: employeeSelectors.getExclusionReasonDetails(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setShowExcludeEmployeeFromAlertsAddModal: actionCreators.SetShowExcludeEmployeeFromAlertsAddModal,
  addAlertExclusion: actionCreators.AddAlertExclusion,
  clearDataAlertExlusionForm: actionCreators.ClearDataAlertExlusionForm,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(ExcludeEmployeeFromAlertsAddWizard);
